import { siteData } from "../../constants";

export const authenticatedFetch = async <ReturnType>(
    input: RequestInfo,
    init: RequestInit = {},
): Promise<ReturnType> => {
    const defaultHeaders = {};

    const baseUrl = siteData.installPath === "/" ? "" : siteData.installPath;

    const response = await fetch(baseUrl + input, {
        ...init,
        headers: {
            ...defaultHeaders,
            ...init.headers,
        },
    });
    const json = await response.json();
    if (response.status < 200 || response.status >= 400) {
        throw json;
    }
    return json;
};
